import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AssetSortingType } from 'app/models/asset-sorting-type';
import { FileSorting } from 'app/models/file-sorting.enum';

@Component({
  selector: 'app-dropdown-sort',
  templateUrl: './dropdown-sort.component.html',
  styleUrls: ['./dropdown-sort.component.scss']
})
export class DropdownSortComponent implements OnInit {
  options: Array<AssetSortingType> = [
    {
      name: 'New Added',
      id: FileSorting.TimeCreated
    },
//  {
//    name: 'New Updated',
//    id: FileSorting.TimeUpdated
//  },
  {
    name: 'A - Z',
    id: FileSorting.NameAsc
  },
  {
    name: 'Z - A',
    id: FileSorting.NameDesc
  }
];

  @Input() label = 'SORT BY:';
  @Output() select = new EventEmitter();

  selected: AssetSortingType = this.options[1];

  constructor() { }

  ngOnInit() {
    this.onSelect(this.selected);
  }

  onSelect(item) {
    this.selected = item;
    this.select.emit(item);
  }
}
